import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_8 from '../../assets/press/21-Hollywood.jpg';

const pressList = [
	{
		image: P_1,
		title:
			'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
		link: ROUTE_NAMES.PRESS1,
	},
	{
		image: P_2,
		title:
			'21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
		link: ROUTE_NAMES.PRESS2,
	},
	{
		image: P_3,
		title:
			'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
		link: ROUTE_NAMES.PRESS3,
	},
];

export default function PressPage8() {
	const location = useLocation();
	const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

	return (
		<div className='press-single-page'>
			<Helmet>
				<title>Starlife: Group Building Hollywood Apartment Project</title>
				<meta
					name='description'
					content='The 13-story tower, situated on the 1.48-acre site at 2100 N. Federal Highway, will be across from South Broward High School.'
				/>
				<meta
					name='keywords'
					content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
				/>
				<link rel='canonical' href={canonicalUrl} />
			</Helmet>
			<div className='col-1'>
				<img src={P_8} alt='press-image' />
				<h2 className='press-page-title'>
					Starlife Group Building Hollywood Apartment Project
				</h2>
				<span className='author-name'>By Mike Boyd</span>
				<span className='author-name'>December 9, 2024</span>
				<Link
					to={
						'https://www.connectcre.com/stories/starlife-group-building-hollywood-apartment-project/'
					}
				>
					<span className='author-name'>Source</span>
				</Link>

				<div className='press-page-content'>
					<p>
						<b>Starlife Group</b> has started work on the 21 Hollywood apartment
						complex.
					</p>
					<p>
						The 13-story tower, situated on the 1.48-acre site at 2100 N.
						Federal Highway, will be across from South Broward High School. The
						building will feature 200 apartments, 10,000 square feet of retail
						and 301 parking spaces. Amenities will include a pool deck, a game
						room, a fitness center with a yoga/pilates room, a wellness center
						with a sauna, a movie room, a coworking space, a children’s play
						area, and a dog park. The apartments will include penthouses on the
						upper levels.
					</p>
					<p>
						It was designed by Miami-based Kobi Karp Architecture. The developer
						is serving as the general contractor through Starlife Builders. It
						should be completed in early 2027.
					</p>
					<p>
						The S. Florida Business Journal reports the developer, who purchased
						the property for $6.5 million in 2023, expects to obtain a $35
						million construction loan for the project.
					</p>
				</div>
			</div>
			<div className='col-2'>
				<div className='sticky-press-list'>
					<h3>Press Articles</h3>
					{pressList.map((item, idx) => (
						<Link to={item.link} key={idx}>
							<div className='other-press-card'>
								<img src={item.image} alt={`press-${idx}`} />
								<p>{item.title}</p>
							</div>
						</Link>
					))}
					<Link to={ROUTE_NAMES.PRESS}>
						<button className='view-all-press-btn'>View All</button>
					</Link>
				</div>
			</div>
		</div>
	);
}
